import { Component, OnInit } from '@angular/core';
import { TrackingPageService } from '@pages/checkout-app/checkout-layout/main/components/tracking-page/tracking-page.service';
import { ShopService } from '@services/shops/shop.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'tracking-page',
  templateUrl: './tracking-page.component.html',
  styleUrls: ['./tracking-page.component.scss'],
  standalone: false,
})
export class TrackingPageComponent implements OnInit {
  shop$ = this.shopService.shop$;
  trackingPageConfiguration$ = this.trackingPageService.trackingPageConfiguration$;
  isConfigurationLoading$ = this.trackingPageService.isConfigurationLoading$;
  shopRequirements$: Observable<{ updateRequired: boolean; updateAppUrl: string }>;
  constructor(
    private trackingPageService: TrackingPageService,
    private shopService: ShopService,
  ) {}

  ngOnInit(): void {
    this.shopRequirements$ = this.shopService.getUrlToUpdateAppIfRequired(['write_discounts']).pipe(
      map((res) => {
        return { updateRequired: res.requireUpdate, updateAppUrl: res.updateUrl };
      }),
    );
  }
}
